module.exports = __webpack_public_path__ + "media/images/flags/1x1/tkm-bf18742fa8dc0edf3cf89ffe83523598.svg";